<template>
	<nk-dropdown v-model="dropdownValue" :data="dropdownData" :options="settings.dropdownOptions" ref="input" :tabindex="tabindex"></nk-dropdown>
</template>
<script>
	import _ from 'lodash'
	import { mapActions, mapGetters } from 'vuex'
	import $sc from '~/plugins/shortcut.collection.js'
	import ProductClassificationsList from '~/views/sale/products/product-classification-list'

	export default {
		props: {
			modelValue: {},
			options: {},
			tabindex: {}
		},
		emits: ['update:modelValue'],
		data() {
			return {
				settings: {
					type: null,
					dropdownOptions: {
						rowIdentifier: 'id',
						remoteSearch: false,
						placeholder: this.$t('select-it'),
						searchableFields: ['name'],
						findExactMatch: this.findExactMatch,
						selectorWidth: 'auto',
						buttons: [{
							title: this.$t('manage-items'),
							shortcut: $sc.find('enter'),
							element: () => { return this.$el },
							isPrimary: true,
							icon: 'list-ul',
							handle: (button, page, e) => {
								this.showProductClassifications()
							}
						}]
					}
				},
				localValue: null
			}
		},
		computed: {
			...mapGetters({
				all: 'productClassifications/all'
			}),
			dropdownValue: {
				get() {
					return this.localValue
				},
				set(val) {
					this.$emit('update:modelValue', val)
					this.localValue = val
				}
			},
			dropdownData() {
				return this.all
			}
		},
		watch: {
			modelValue: {
				handler(val, oldVal) {
					this.localValue = val
				}
			},
			options: {
				immediate: true,
				deep: true,
				handler(val) {
					this.settings = _.extend({}, this.settings, val)
				}
			}
		},
		created() {
			this.localValue = this.modelValue
		},
		mounted() {
			this.refreshProductClassifications()
		},
		methods: {
			...mapActions({
				broadcastRefresh: 'socket/broadcastRefresh',
				refreshProductClassifications: 'productClassifications/refresh'
			}),
			showProductClassifications() {
				this.showModal({ component: ProductClassificationsList, options: { filterType: 'all', modelValue: this.dropdownValue } })
					.then(result => {
						//this. broadcastRefresh('ProductClassifications')
						this.dropdownValue = result
						this.$refs.input.focusAndSelect()
					}).catch(() => { })
			}
		},
	}
</script>
<style></style>
